import { AttributeGroupType, AttributeGroupValueDTO } from "@touche-lts/panel-ui/dist"

export enum AttributeTypes {
  COLOR = 'Color',
  SIZE = 'Size',
  CUSTOM = 'Custom'
}

export class Attribute {
  id: number
  name: string
  type: AttributeTypes
  attributeName: string
  value: any

  constructor (attribute: Attribute) {
    for (const property in attribute) {
      this[property] = attribute[property]
    }
  }
}

export interface AttributeGroup {
  id: number;
  name: string;
  type: string;
  opt: boolean;
  values: Attribute[];
}

export interface AttributeGroupN {
  id: number;
  name: string;
  type: string;
  opt: boolean;
  values: Attribute[];
  status?: string
  createdDate?: number
}

export interface AttributeGroupDTO {
  createdDate?: number;
  id: number;
  name: string;
  opt: boolean;
  status?: string;
  type: AttributeGroupType | string;
  values: AttributeGroupValueDTO[] | Attribute[];
  //1
}